import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, PageHeader} from 'react-bootstrap'
import config from '../../config'
import ReportCard from './ReportCard'

function reportFilter(audit) {
    return (report) => {
        return report.parentAudit.uid == audit.uid
    }
}

function auditAggregator(result, report) {
    var audit = result.find((a) => a.uid == report.parentAudit.uid)

    if (!audit) {
        result.push(report.parentAudit)
    }
    return result
}

function scoreSumAggregator(result, audit) {
    return result + audit.score
}

function aggregate(reports) {
    const audits = reports.reduce(auditAggregator, [])
    const aggregations = audits.map((audit) => {
        const auditReports = reports.filter(reportFilter(audit))
        const auditScore = Math.round(auditReports.reduce(scoreSumAggregator, 0) / auditReports.length * 100) / 100

        return {
            audit: audit,
            reports: auditReports,
            score: auditScore
        }
    })

    return aggregations
}

class ReportStream extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
            aggregations: []
        }
    }

    componentWillMount() {
        const {stream} = this.props

        const aggregations = aggregate(stream)
        this.setState({aggregations})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.stream != this.props.stream) {
            const {stream} = nextProps
            
            const aggregations = aggregate(stream)
            this.setState({aggregations})
        }
    }

    _openReportWindow(event, report) {
        event.preventDefault()
        window.open(config.audit.url + '/audits/' + report.uid + '/report')
    }

    render() {
        const {aggregations} = this.state

        return (
            <div>
                {aggregations.map((aggrega, index) => (
                    <div key={index}>
                        <PageHeader>
                            <span>Audit {aggrega.audit.name}</span>
                            <span> ({aggrega.reports.length})</span>
                            <span> - {aggrega.score * 100} %</span>
                        </PageHeader>
                        <Row>
                            {aggrega.reports.map((report) => (
                                <Col
                                    key={report.uid}
                                    sm={4}>
                                    <ReportCard
                                        report={report}
                                        onClick={(e) => this._openReportWindow(e, report)} />
                                </Col>
                            ))}
                        </Row>
                    </div>
                ))}
            </div>
        )
    }
}

ReportStream = connect((state) => ({
    stream: state.audit.report.stream
}))(ReportStream)

export default ReportStream


// WEBPACK FOOTER //
// ./lib/audit/components/ReportStream.js